<loading-component *ngIf="!component" class="center"></loading-component>
<app-base-template [component]="component" [componentDef]="componentDef" [scope]="this"
    [customGetTextMethod]="overloadGetText" *ngIf="component">
</app-base-template>